import React from 'react'
import { Link } from 'react-router-dom'
import auth from '../../modules/auth'
import RequestInformationTable from '../RequestInformation/RequestInformationTable'

// Import Image
import iconAccount from '../../images/icon-account.svg'
import iconRequest from '../../images/icon-request.svg'
import iconRequestEdit from '../../images/icon-request-edit.svg'

// Import Scss
import './Sidebar.scss'

class Sidebar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      photoIndex: 0,
      openLightBox: false,
    }
    this.setWrapperRefSubMenu = this.setWrapperRefSubMenu.bind(this)
    this.handleClickLink = this.handleClickLink.bind(this)
    this.handleClickOutsideSubMenu = this.handleClickOutsideSubMenu.bind(this)
  }
  componentDidMount() {
    if (this.props.openSubMenu) this.props.toggleSubMenu()
    this.props.fetchSidebarDataRequest()
    // handle click outside submenu
    document.addEventListener('mousedown', this.handleClickOutsideSubMenu)
  }

  componentWillReceiveProps(nextProps) {
    // redirect to signup step 2 -> 5 to edit if autosave
    if (nextProps.isSavedByCustomer === false) {
      this.props.history.push('/signup')
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideSubMenu)
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRefSubMenu(node) {
    if(this.props.isModal) {
      this.wrapperRefSubMenuModal = node
    } else {
      this.wrapperRefSubMenu = node
    }
  }

  handleClickOutsideSubMenu(event) {
    const isMobile = window.innerWidth <= 991
    let subMenu = isMobile ? this.wrapperRefSubMenuModal : this.wrapperRefSubMenu
    let isOutside = subMenu && !subMenu.contains(event.target) && this.props.openSubMenu
    if(isOutside) {
      this.props.toggleSubMenu()
    }
  }
  handleClickLink() {
    if(this.props.toggleUserInfoModal){
      this.props.toggleUserInfoModal()
    }
  }
  render() {
    let props = this.props

    // Customer Info
    const emailCustomer = auth.getCustomerInfoBy('email')

    return (
      <div className="sidebar">
        {!!props.status &&
        <div className="sidebar__inner">
          <div className="sidebar__account">
            <div className="sidebar__account__title">
              <img src={iconAccount} alt="" />
              <span>{emailCustomer}</span>
            </div>
            <div ref={this.setWrapperRefSubMenu}
              className="sidebar__account__menu-wrap">
              <button
                className={"sidebar__account__menu-button " + props.openSubMenu} onClick={props.toggleSubMenu}>
              </button>
              {props.openSubMenu &&
                <div>
                  <ul className="sidebar__account__menu-list">
                    <li>
                      <Link
                        to="/payments"
                        className="btn btn-sidebar-sub-menu"
                        onClick={this.handleClickLink}>
                        購入履歴
                      </Link>
                    </li>
                  </ul>
                </div>
              }
            </div>
          </div>
          <div className="sidebar__request">
            <div className="sidebar__request__title">
              <img src={iconRequest} alt="" />
              <span>相談内容</span>
            </div>
            {props.editable && <div className="sidebar__request__edit-button-wrapper">
              { (!props.contentConsultation ||
                (!props.files.length && props.submissionMethod !== 'post')) &&
                <div className="sidebar__request__edit-label">
                  <img src={iconRequestEdit} alt="" />
                  <p>より正確なセカンドオピニオンのために、詳細を入力しましょう</p>
                </div>
              }
              <Link
                to="/request/edit"
                className="sidebar__request__edit-button custom-control-button"
                onClick={this.handleClickLink}>
                相談詳細の編集・<br/>
                資料アップロード
              </Link>
            </div>}
            <div className="sidebar__request__detail-wrapper">
              <RequestInformationTable
                {...props}
              />
            </div>
          </div>
        </div>
        }
      </div>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js